module.exports = __webpack_public_path__ + "static/media/mq.a09e4865.svg";